export default __webpack_public_path__ + "static/media/wenasports.b209e7b5.png";